import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CKEDITOREMAILCONFIG } from '../ckeditor-config';
import { HttpService } from '../service/http.service';
import { LeadEmailTemplate } from '../lead-email-template';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-edit-lead-email-template',
  templateUrl: './edit-lead-email-template.component.html',
  styleUrls: ['./edit-lead-email-template.component.css']
})
export class EditLeadEmailTemplateComponent implements OnInit {

  selectedTemplate!: LeadEmailTemplate;
  templateForm!: FormGroup;
  processing = false;

  emailEditorConfig = CKEDITOREMAILCONFIG; 

  public Editor = Editor;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let templateId = this.route.snapshot.paramMap.get("templateId");
    this.httpService.getLeadEmailTemplateById(Number(templateId)).subscribe(res => {
      this.selectedTemplate = res;
      this.templateForm = this.builder.group({
          name: [this.selectedTemplate.name, Validators.required],
          body: [this.selectedTemplate.body, Validators.required],
          language: [this.selectedTemplate.language, Validators.required],
          subject: [this.selectedTemplate.subject, Validators.required]
      });
    });
  }

  updateTemplate(){
    if(this.templateForm.invalid){
      this.toastService.addError("Error", "Please complete the form");
      return;
    }
    this.selectedTemplate.name = this.templateForm.value.name;
    this.selectedTemplate.body = this.templateForm.value.body;
    this.selectedTemplate.subject = this.templateForm.value.subject;
    this.processing = true;
    this.httpService.updateLeadEmailTemplate(this.selectedTemplate).subscribe(() => {
      this.toastService.addSuccess("Success", "Updated successfully");
      this.processing = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.processing = false;
    });
  }

  deleteTemplate(){
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete this record?",
      accept: () => {
        this.httpService.deleteLeadEmailTemplate(this.selectedTemplate.id!).subscribe(() => {
          this.router.navigateByUrl("/management/lead-email-templates");
        });
      }
    });
  }

}
